import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { useSetAtom } from "jotai";
import SectionRecord from "models/view-models/section-record";
import React from "react";
import { DroppedSection } from "utilities/atoms/section-drag-and-drop/dropped-section";

interface NotebookSectionContextMenuProps {
    section: SectionRecord;
}

const NotebookSectionContextMenu: React.FC<NotebookSectionContextMenuProps> = ({
    section,
}) => {
    const CSS_CLASS_NAME = "c-notebook-section-context-menu";
    const setDroppedSection = useSetAtom(DroppedSection);
    const onButtonClick = () => {
        setDroppedSection(section);
    };
    return (
        <div className={CSS_CLASS_NAME}>
            <button
                className={`${CSS_CLASS_NAME}__button`}
                onClick={onButtonClick}>
                <Icon
                    cssClassName={`${CSS_CLASS_NAME}__icon`}
                    type={Icons.Plus}
                />
            </button>
        </div>
    );
};

export default NotebookSectionContextMenu;
